import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function TeamLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!username.trim() || !password.trim()) {
      setError('Please enter both username and password.');
      return;
    }

    setLoading(true);
    try {
      await login(username, password, 'team');
      navigate('/team/staff');
    } catch (err) {
      setError(err.message || 'Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>NEOM Hospital</h1>
          <p style={styles.brandSub}>Academic & Training Affairs Hub</p>
          <div style={styles.divider} />
          <h2 style={styles.portal}>Team Portal</h2>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg w-full"
            disabled={loading}
            style={{ marginTop: '8px' }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>

          <div style={styles.footer}>
            <a href="#" style={styles.link}>
              Forgot Password?
            </a>
            <Link to="/" style={styles.link}>
              Back to Home
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#F5F0E8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  card: {
    background: '#ffffff',
    borderRadius: '16px',
    padding: '40px 36px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
  },
  header: {
    textAlign: 'center',
    marginBottom: '28px',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#2B362E',
    margin: 0,
  },
  brandSub: {
    fontSize: '0.8rem',
    color: '#B2AB9C',
    marginTop: '4px',
  },
  divider: {
    width: '40px',
    height: '3px',
    backgroundColor: '#6B8063',
    margin: '16px auto',
    borderRadius: '2px',
  },
  portal: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: '#6B8063',
    margin: 0,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  error: {
    backgroundColor: '#fde8e8',
    color: '#C0392B',
    padding: '10px 14px',
    borderRadius: '8px',
    fontSize: '0.85rem',
    marginBottom: '16px',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px',
  },
  link: {
    fontSize: '0.85rem',
    color: '#6B8063',
    textDecoration: 'none',
    fontWeight: 500,
  },
};
